import React from "react";
import loading from "../../photos/Spinner-1.9s-137px.gif";

// Loading component to display a loading spinner
const Loading = ({ height }) => {
  return (

    <div
      className={`flex flex-col justify-center items-center w-24 ${height} m-auto bg-transparent `}>
      <img src={loading} alt="" />
    </div>
  );
};
export default Loading;